import React from 'react';
import PropTypes from 'prop-types';
import { Table, DropdownButton, MenuItem } from 'react-bootstrap';

const InstallerTableComponent = ({
  files,
  hasSelectedFiles,
  selectAll,
  setSelectedAsExpected,
  tableRows,
  secondColumnName,
  thirdColumnName,
  fourthColumnName,
  acknowledgeColumn,
  dropDownColumn,
  buttonColumn,
}) => {
  return (
    <Table bordered condensed hover className="metrics-table">
      <thead>
        <tr key={'Head'}>
          { dropDownColumn ?
            <th scope="col">
              <DropdownButton bsSize="xsmall" title=" " id="dropdown-size-extra-small">
                <MenuItem
                  id="select-all-button"
                  onClick={() => selectAll(files, true)}
                >
                  Select All
                </MenuItem>
                <MenuItem
                  id="unselect-all-button"
                  onClick={() => selectAll(files, false)}
                >
                  Unselect All
                </MenuItem>
                <MenuItem divider />
                <MenuItem header>Set Selected As</MenuItem>
                <MenuItem
                  id="set-selected-as-expected"
                  disabled={!hasSelectedFiles}
                  onClick={() => setSelectedAsExpected(files, true)}
                >
                  Expected
                </MenuItem>
                <MenuItem
                  id="set-selected-as-not-expected"
                  disabled={!hasSelectedFiles}
                  onClick={() => setSelectedAsExpected(files, false)}
                >
                  Not Expected
                </MenuItem>
              </DropdownButton>
            </th> : null
          }
          <th scope="col">File Name</th>
          <th scope="col">{secondColumnName}</th>
          {thirdColumnName ? <th scope="col">{thirdColumnName}</th> : null}
          {fourthColumnName ? <th scope="col">{fourthColumnName}</th> : null}
          <th scope="col">{acknowledgeColumn}</th>
          {buttonColumn ? <th /> : null}
        </tr>
      </thead>
      <tbody>
        {tableRows}
      </tbody>
    </Table>
  );
};

InstallerTableComponent.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    filename: PropTypes.string,
    added: PropTypes.bool,
    expected: PropTypes.bool,
    selected: PropTypes.bool
  })),
  hasSelectedFiles: PropTypes.bool,
  selectAll: PropTypes.func,
  setSelectedAsExpected: PropTypes.func,
  tableRows: PropTypes.array.isRequired,
  secondColumnName: PropTypes.string,
  thirdColumnName: PropTypes.string,
  fourthColumnName: PropTypes.string,
  acknowledgeColumn: PropTypes.string,
  dropDownColumn: PropTypes.bool,
  buttonColumn: PropTypes.bool
};

export default InstallerTableComponent;


// WEBPACK FOOTER //
// src/Components/InstallerTableComponent.jsx